  /*============ Content Controller
  ================================*/
  angular
      .module('vppApp')
      .controller('brandLogoController', brandLogoController);

    brandLogoController.$inject = ['$scope', '$state', 'brandLogoFactory', '$stateParams', 'vppConfig', 'SetLiveSwapService'];

    function brandLogoController($scope, $state, brandLogoFactory, $stateParams, vppConfig, SetLiveSwapService){
      brandLogoFactory().then(function (response) {
        var liveswap = SetLiveSwapService.getLSBrandName();
        var lsbrand = vppConfig.lsBrands[liveswap];
        $scope.brandLogosComponent = [];
        
        //if values are in storage
        if(lsbrand){
          var lsBrands = lsbrand;
          for(var i = 0; i < lsBrands.length; i++){
            var thisBrand = lsBrands[i].toLowerCase();

            var obj = {
              "imgSrc" : response.data['brands'][thisBrand]["imgSrc"]
            }
            if(response.data['brands'][thisBrand]["state"][$state.current.name]){
              obj["state"] = response.data['brands'][thisBrand]["state"][$state.current.name];
            }
            $scope.brandLogosComponent.push(obj);
          }
        } else {
          var lsBrands = response.data.brands;
          for(var i = 0; i < Object.keys(lsBrands).length; i++){
            var j = Object.keys(lsBrands)[i]
            var obj = {
              "imgSrc" : response.data['brands'][j]["imgSrc"]
            }
            if(response.data['brands'][j]["state"][$state.current.name]){
              obj["state"] = response.data['brands'][j]["state"][$state.current.name];
            }
            $scope.brandLogosComponent.push(obj);
          }
        }
        
        $scope.siteCode = vppConfig.folderPath;

      });
  };